import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import landingSun from "../../assets/images/sun.png";
import beeFlower from "../../assets/images/bee-flower.svg";
import btnQuizImage from "../../assets/images/btn-quiz.png";
import btnSearchImage from "../../assets/images/btn-search-find.png";
import btnColorImage from "../../assets/images/btn-colour-me.png";
import btnUnitedKingdomImage from "../../assets/images/btn-quiz-uk.png";
import btnMatchingPairsImage from "../../assets/images/btn-matching-pairs.png";
import { CloseButton } from "../components/CloseButton";
import { AppMode } from "../../AppMode";
import { SunAnimation } from "../components/animations/SunAnimation";
import { PlaneAnimation } from "../components/animations/PlaneAnimation";
import { BeeAnimation } from "../components/animations/BeeAnimation";

export interface GamesActivitiesScreenProps
{
}

interface GamesActivitiesScreenState 
{
}

export class GamesActivitiesScreen extends Component<GamesActivitiesScreenProps, GamesActivitiesScreenState>
{
    constructor(props: GamesActivitiesScreenProps)
    {
        super(props);

        this.state = {
        };
    }

    private onCloseClicked(): void 
    {
        App.I.changeScreen(AppScreen.Landing);
    }

    public render(): JSX.Element
    {
        return (
            <>
                <CloseButton onClicked={this.onCloseClicked.bind(this)} />

                <div className="games-activities-screen">

                    <div className="sun">
                        {/* <SunAnimation /> */}
                    </div>

                    <div className="animation-plane">
                        <PlaneAnimation />
                    </div>

                    <div className="container">
                        <div className="landing-container">

                            <h1 className="lead-title text-uppercase text-center">
                                Games and Activities
                            </h1>

                            <div className="d-flex mt-auto btn-container">
                                <button className="btn btn-search" onClick={() => App.I.changeScreen(AppScreen.SearchAndFind)} title="Search and Find">
                                    <img src={btnSearchImage} alt="Characters with binoculars." />
                                </button>

                                <button className="btn btn-search" onClick={() => App.I.changeScreen(AppScreen.MatchingPairs)} title="Matching Pairs">
                                    <img src={btnMatchingPairsImage} alt="Character holding matching pair of cards" />
                                </button>

                                <button className="btn btn-colour" onClick={() => App.I.changeScreen(AppScreen.ColourMe)} title="Painting">
                                    <img src={btnColorImage} alt="Character with paintbrush." />
                                </button>

                                {App.I.appMode === AppMode.Arrivals ?
                                    <button className="btn btn-quiz" onClick={() => App.I.changeScreen(AppScreen.Quiz)} title="Holiday Quiz">
                                        <img src={btnQuizImage} alt="Characters looking at the world, holding passports." />
                                    </button>
                                    :
                                    <button className="btn btn-quiz" onClick={() => App.I.changeScreen(AppScreen.Quiz)} title="Holiday Quiz">
                                        <img src={btnQuizImage} alt="Characters looking at the world, holding passports." />
                                    </button>
                                }
                            </div>

                            <div className="p-3 text-center">
                                <button className="btn btn-link" onClick={() => App.I.changeScreen(AppScreen.Landing)}>
                                    Back to home
                                    <i className="bi bi-chevron-right ps-1"></i>
                                </button>

                                <div className="bee-flower">
                                    {/* <img src={beeFlower} alt="Bee and flower" /> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="animation-bee">
                        {/* <BeeAnimation /> */}
                    </div>

                </div>
            </>
        );
    }
}